<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-avatar
        v-bind="attrs"
        v-on="on"
        color="indigo"
        size="40"
      >
        <v-icon
          v-if="firstInitial !== ''"
          size="31"
          dark
          :class="secondInitial !== '' ? 'mr-n4' : ''"
        >
          mdi-alpha-{{ firstInitial }}
        </v-icon>
        <v-icon
          v-else
          size="31"
          dark
        >
          mdi-account-circle
        </v-icon>
        <v-icon
          v-if="secondInitial !== ''"
          size="31"
          dark
        >
          mdi-alpha-{{ secondInitial }}
        </v-icon>
      </v-avatar>
    </template>
    <div class="text-center">
      <span>{{ userName }}</span>
      <br />
      <span>{{ userEmail }}</span>
      <span
        v-if="isParameterizer"
        class="d-block"
      >
        Parameterizer
      </span>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: 'AppAvatar',

  data () {
    return {
    };
  },

  props: {
    userName: {
      type: String,
      required: false,
      default: '',
    },
    userEmail: {
      type: String,
      required: false,
      default: '',
    },
    isParameterizer: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  computed: {
    firstName() {
      return this.userName.split(' ')[0]
    },
    lastName() {
      return this.userName.split(' ')[1]
    },
    firstInitial() {
      return this.firstName ? this.firstName.substring(0, 1).toLowerCase() : ''
    },
    secondInitial() {
      return this.lastName ? this.lastName.substring(0, 1).toLowerCase() : ''
    }
  }

};
</script>